export default __webpack_public_path__ + "static/media/kafe_icon.b2f01db0.png";